<template>
  <div>
    <breadcrumb
      :booking-status="allObject.booking.status_id"
      :booking-number="allObject.booking.booking_num"
      :booking-estimate="allObject.bookingEstimate"
      :booking-estimate-is-deleted="allObject.bookingEstimate.is_deleted"
      :booking-estimate-number="allObject.bookingEstimate.estimate_num"
      :item-object="allObject.booking"
      :booking-invoice="allObject?.bookingInvoice"
      :logged-user="allObject.loggedUser"
      :contractor-role-id="1"
      :has-recurring="allObject.hasRecurring"
      :estimate-data="allObject.estimateData"
      :allow-fieldworker-add-booking="allObject.allowFieldworkerAddBooking"
      :status="allObject.status"
      :item-string="allObject.itemString"
      :is-repeated="allObject.isRepeated"
      :parent-num="allObject.parentNum"
      :is-accepted="allObject.isAccepted"
      :show-billing-info-condition="allObject.showBillingInfoCondition"
      :has-multiple-open-cycles="allObject.hasMultipleOpenCycles"
      :parent-id="allObject.parentId"
      :estimate-params="allObject.estimateParams"
      :shown-horizontal-line="allObject.shownHorizontalLine"
      :nearest-booking-params="allObject.nearestBookingParams"
      :find-availability-params="allObject.shownHorizontalLine"
      :all-credentials-array="allObject.all_Credentials_array"
      :can-delete="allObject.canDelete"
      :logged-user-role="(allObject.loggedUser || {}).role_name"
      :view-page="true"
      item-type="booking"
      :company="allObject.company"
      :customer-role="9"
    >
    </breadcrumb>

    <div class="row mobile-m-r-l">
      <div class="">
        <div class="ibox float-e-margins fadeInRight">
          <div class="tabbable new-tabs">
            <ul class="nav nav-tabs p-top-6 m-bottom-10" id="myTab">
              <li :class="{ active: activeTab === 'overview' }">
                <a class="tab-text tab-li" @click="activeTab = 'overview'">Overview</a>
              </li>
              <li
                :class="{
                  active: activeTab === 'communication',
                  'mobile-m-bottom-5': true,
                }"
              >
                <a class="tab-text tab-li" @click="activeTab = 'communication'"
                  >Communication</a
                >
              </li>
              <li
                :class="{
                  active: activeTab === 'communicationvue2',
                  'mobile-m-bottom-5 hidden communicationvue2': true,
                }"
              >
                <a class="tab-text" @click="activeTab = 'communicationvue2'"
                  >Communication vue2</a
                >
              </li>

              <li :class="{ active: activeTab === 'issuesvue2' ,  'mobile-m-bottom-5 hidden activityvue2 tab-li': true,}">
                <a
                  class="tab-text  tab-li "
                  @click="
                    activeTab = 'issuesvue2';
                    hideTabs('tabs-complaint');
                  "
                  >Issues vue2 ({{ totalIssues }})</a
                >
              </li>
              <li :class="{ active: activeTab === 'issues' }">
                <a id="countIssues" class="tab-text tab-li" @click="activeTab = 'issues'"
                  >Issues ({{ totalIssues }})</a
                >
              </li>

              <li :class="{ active: activeTab === 'activity' }">
                <a class="tab-text tab-li" @click="activeTab = 'activity'">Activity</a>
              </li>
              <li
                :class="{
                  active: activeTab === 'activityvue2',
                  'mobile-m-bottom-5 hidden activityvue2 tab-li': true,
                }"
              >
                <a class="tab-text" @click="activeTab = 'activityvue2'"
                  >Activity Vue2</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <overview-tab
                :allObject="allObject"
                v-show="activeTab === 'overview'"
              ></overview-tab>
              <div
                class="vue3-component"
                v-show="activeTab === 'communication'"
                id="BookingCommunicationTabs"
              ></div>
              <div>
                <communication-tabs
                  :itemType="itemType"
                  :itemId="itemId"
                  :bookingId="allObject.booking.booking_id"
                  :complaint-id="complaintId"
                  :credentials="allObject.tabsCredentials"
                  :customer-id="allObject.booking.customer_id"
                  v-if="activeTab === 'communicationvue2'"
                ></communication-tabs>
                <activity-tabs
                  v-if="activeTab === 'activityvue2'"
                  :itemType="itemType"
                  :itemId="itemId"
                  :bookingId="allObject.booking.booking_id"
                  :credentials="allObject.tabsCredentials"
                  :customer-id="allObject.booking.customer_id"
                >
                </activity-tabs>
                <div
                  class="vue3-component"
                  v-show="activeTab === 'activity'"
                  id="activityTabsVue3"
                ></div>
                <issues-tab
                  v-show="activeTab === 'issuesvue2'"
                  :itemType="itemType"
                  :itemId="itemId"
                  :bookingId="allObject.booking.booking_id"
                  :credentials="allObject.tabsCredentials"
                  :show-view-issues-popup="allObject.show_issues_popup"
                  :logged-user="allObject.loggedUser"
                  :s3-path="allObject.s3Path"
                  @issuesCountUpdated="totalIssues = $event"
                >
                </issues-tab>
                <div
                  class="vue3-component"
                  v-show="activeTab === 'issues'"
                  id="issuesTabsVue3"
                ></div>
                <view-issue-popup
                  v-if="this.allObject.show_issues_popup"
                  :complaint-id="this.allObject.show_issues_popup"
                  :show-view-issues-popup="this.allObject.show_issues_popup"
                  tabName="viewBooking"
                ></view-issue-popup>
              </div>
              <reject-accept-admin-services
                :s3-path="allObject.s3Path"
                :modal-id="
                  allObject.booking.status_id === 3
                    ? `custom_object_${allObject.bookingEstimate.id}`
                    : `custom_object_${allObject.booking.booking_id}`
                "
                :booking-id="
                  allObject.booking.status_id === 3
                    ? allObject.bookingEstimate.id
                    : allObject.booking.booking_id
                "
                :visits="allObject.mergedVisitsForAll"
              >
              </reject-accept-admin-services>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import {
  deleteComplaint,
  getSingleTabData,
} from "@/modules/Booking/api/BookingViewTabs";

export default {
  name: "ViewBooking",
  props: {
    allObject: {
      type: Object,
    },
  },
  computed: {
    itemType() {
      return this.allObject.booking.status_id === 3 &&
        this.allObject.bookingEstimate.id
        ? "estimate"
        : "booking";
    },
    itemId() {
      return this.allObject.booking.status_id === 3 &&
        this.allObject.bookingEstimate.id
        ? this.allObject.bookingEstimate.id
        : this.allObject.booking.booking_id;
    },
  },
  data() {
    return {
      activeTab: this.allObject.show_issues_popup ? "issues" : "overview",
      totalIssues: 0,
      complaintId: 0,
    };
  },
  methods: {
    // showTabs(){
    //   if (document.getElementById('tabsDiv')){
    //     document.getElementById('tabsDiv').classList.remove('hidden');
    //     let tabsDiv = document.getElementById('tabsDiv');
    //     this.$nextTick(()=>{
    //       document.getElementById('ActivityTab').appendChild(tabsDiv)
    //     })
    //   }
    // },
    hideTabs(tab = "CommunicationTab") {
      if (document.getElementById("tabsDiv")) {
        document.getElementById("tabsDiv").classList.add("hidden");
        let tabsDiv = document.getElementById("tabsDiv");
        this.$nextTick(() => {
          document.getElementById(tab).appendChild(tabsDiv);
        });
      }
    },
    fetchData() {
      let params = {
        type: "complaint",
        booking_id: this.itemId,
        fromVuejs: true,
      };
      getSingleTabData(params).then((response) => {
        this.bookingComplaints = response.data.bookingComplaints;
        this.bookingId = response.data.bookingId;
        this.dateTimeObj = response.data.dateTimeObj;
        this.$emit("issuesCountUpdated", this.bookingComplaints.length);
      });
    },
  },
  mounted() {
    // make on event bus and make on it the active tab is communications
    EventBus.$on("showDiscussions", (complaintId) => {
      this.activeTab = "communication";
      this.complaintId = complaintId;
      this.$nextTick(() => {
        EventBus.$emit("showDiscussionsIssue", complaintId);
      });
    });
  },
};
</script>

<style scoped>
.add-booking-container-width .fieldworker-box .select2-selection__rendered {
  justify-content: flex-start !important;
  display: flex !important;
}

.sub-fieldworker-box .select2-selection__rendered {
  width: 100% !important;
}

.new-tabs {
  background-color: #ffffff;
}

#myTab {
  border: none;
}

#myTab a {
  background-color: #ffffff !important;
  border: none !important;
  color: rgba(46, 64, 81, 1) !important;
}

#myTab > li.active > a {
  border-bottom: 4px solid #2e4051 !important;
}

.tab-text {
  font-size: 15px;
}

.tabbable {
  padding-bottom: 0;
}

@media (max-width: 768px) {
  .add-booking-container-width .fieldworker-box .select2-selection__rendered {
    width: 100% !important;
  }

  .mobile-m-r-l {
    margin-left: 0px;
    margin-right: 0px;
  }

  .mobile-m-bottom-5 {
    margin-bottom: 5px;
  }
}
</style>
